// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title_3f65V","block":"index_block_3LNVL","inner":"index_inner_aj0vC","form":"index_form_3r-Hz","accountButton":"index_accountButton_1BKZc"};